import './lawyer-lead.scss';

setTimeout(function() {
    document.querySelectorAll('.alert').forEach(function(alert) {
        alert.firstElementChild.click()
    });
}, 3000);
